app.service('stringHighlightService', [function () {
    var DEFAULT_OPTIONS = {
        highlightHtmlTag: 'span',
        highlightCss: 'search__highlight',
        partsDelimiter: ' ',
        fieldDelimiter: ' '
    };
    this.highlight = function (data, parts, field, options) {
        var self = this;
        this.options = Object.assign({}, DEFAULT_OPTIONS, options);
        if (parts && parts.length) {
            if (parts.constructor === String) {
                parts = parts.split(self.options.partsDelimiter);
            }
            var searchParts = parts.map(function (part) {
                return part.trim();
            });
            data.forEach(function (item) {
                if (item[field]) {
                    var datum = item[field] || null;
                    if (datum !== null) {
                        searchParts.forEach(function (part) {
                            datum = datum.replace(new RegExp(part, 'gi'), self._getHTML(part));
                        });
                        item[field] = datum;
                    }
                }
            });
        }
        return data;
    };

    this._getHTML = function (part) {
        return '<' + this.options.highlightHtmlTag + ' class="' + this.options.highlightCss + '">' + part + '</' + this.options.highlightHtmlTag + '>';
    };
}]);